import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import BetaBanner from '@/components/ui/BetaBanner';
import FeedbackModal from '@/components/feedback/FeedbackModal';

const BetaBannerTest = () => {
  const [isFeedbackModalOpen, setIsFeedbackModalOpen] = useState(false);
  const [showBanner, setShowBanner] = useState(false);

  const handleFeedbackClick = () => {
    setIsFeedbackModalOpen(true);
  };

  const handleCloseFeedbackModal = () => {
    setIsFeedbackModalOpen(false);
  };

  const toggleBanner = () => {
    setShowBanner(!showBanner);
    if (!showBanner) {
      // Remove the dismissed flag to show banner again
      localStorage.removeItem('beta-banner-dismissed');
    } else {
      // Set dismissed flag to hide banner
      localStorage.setItem('beta-banner-dismissed', 'true');
    }
  };

  const clearDismissFlag = () => {
    localStorage.removeItem('beta-banner-dismissed');
    setShowBanner(false);
    window.location.reload(); // Reload to test banner visibility
  };

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <div className="bg-white rounded-lg shadow-lg p-6">
        <h1 className="text-2xl font-bold text-gray-900 mb-6">Beta Banner Test</h1>
        
        <div className="space-y-4 mb-6">
          <div className="p-4 bg-gray-50 rounded-lg">
            <h2 className="text-lg font-semibold mb-2">Test Controls</h2>
            <div className="space-x-4">
              <Button onClick={toggleBanner} variant="outline">
                {showBanner ? 'Hide Banner' : 'Show Banner'}
              </Button>
              <Button onClick={clearDismissFlag} variant="outline">
                Clear Dismiss Flag & Reload
              </Button>
            </div>
          </div>

          <div className="p-4 bg-blue-50 rounded-lg">
            <h2 className="text-lg font-semibold mb-2">Environment Detection</h2>
            <div className="space-y-2 text-sm">
              <p><strong>VITE_ENVIRONMENT:</strong> {import.meta.env.VITE_ENVIRONMENT || 'not set'}</p>
              <p><strong>NODE_ENV:</strong> {import.meta.env.MODE}</p>
              <p><strong>Hostname:</strong> {window.location.hostname}</p>
              <p><strong>Is Staging:</strong> {
                (import.meta.env.VITE_ENVIRONMENT === 'staging' || 
                 import.meta.env.MODE === 'development' ||
                 window.location.hostname.includes('staging') ||
                 window.location.hostname.includes('dev')) ? 'Yes' : 'No'
              }</p>
            </div>
          </div>

          <div className="p-4 bg-green-50 rounded-lg">
            <h2 className="text-lg font-semibold mb-2">Banner Status</h2>
            <div className="space-y-2 text-sm">
              <p><strong>Dismissed Flag:</strong> {localStorage.getItem('beta-banner-dismissed') || 'not set'}</p>
              <p><strong>Banner Should Show:</strong> {
                (import.meta.env.VITE_ENVIRONMENT === 'staging' || 
                 import.meta.env.MODE === 'development' ||
                 window.location.hostname.includes('staging') ||
                 window.location.hostname.includes('dev')) && 
                !localStorage.getItem('beta-banner-dismissed') ? 'Yes' : 'No'
              }</p>
            </div>
          </div>
        </div>

        <div className="border-t pt-6">
          <h2 className="text-lg font-semibold mb-4">Banner Preview</h2>
          <div className="relative border rounded-lg overflow-hidden">
            <BetaBanner onFeedbackClick={handleFeedbackClick} />
            <div className="p-4 bg-gray-100">
              <p className="text-gray-600">This is where the banner would appear above the main content.</p>
            </div>
          </div>
        </div>

        {/* Feedback Modal */}
        <FeedbackModal 
          isOpen={isFeedbackModalOpen} 
          onClose={handleCloseFeedbackModal}
        />
      </div>
    </div>
  );
};

export default BetaBannerTest;
